import  React from 'react';

import { NoteBox } from './note_box.jsx';

export class HelpBox extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      open: false
    };
  }


  toggleOpen(){
    this.setState({
      open: !this.state.open
    })
  }

  render() {

    return (
      <div className="help-box">
        <button className={"help-btn" + (this.state.open ? " open" : "") } style={this.props.buttonStyle} onClick={() => this.toggleOpen()}/>
        { this.state.open ?
          <NoteBox data={this.props.data} theme="help"/> : null
        }
      </div>
    );
  }
};
